import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { Formik } from "formik";
import * as React from "react";
import * as Yup from "yup";
import { RegisterLoanBySupplierRequest } from "../../models/loan.model";
import MaterialTextFieldComponent from "../textField/MaterialTextFieldCmp";
import CustomisedButton from "../button/button";
import CountDown from "../countDownCmp/countDown";
import { useMutation } from "react-query";
import {
  SendOtpForGetCustomerInformation,
  VerifyOtpForGetCustomerInformation,
} from "../../services/customer.service";
import { convertToLocalDateTime } from "../../utility/dateUtility";
import {
  customerInformationRequest,
  customerInformationResponse,
  verifyCustomerInformationRequest,
} from "../../models/customer.model";
import { useState } from "react";
const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
interface Imodal extends customerInformationRequest {
  disable: boolean;
  setDataVerifyCustomer: Function;
}
export default function ModalWithOtp({
  disable,
  birthDate,
  branchId,
  nationalCode,
  setDataVerifyCustomer,
}: Imodal) {
  const [open, setOpen] = useState<boolean>(false);
  const [dataSendOtp, setDataSendOtp] = useState<customerInformationResponse>();

  const handleClose = () => setOpen(false);

  const validationFatcorNumber = Yup.object().shape({
    otp: Yup.string()
      .required("فیلد اجباری است.")
      .matches(/^[0-9]+$/, "کد استعلامی عدد می باشد."), //.min(5).max(5)
  });
  const { mutateAsync: SendOtpForGetCustomerInformationMutate } = useMutation(
    SendOtpForGetCustomerInformation,
    {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setDataSendOtp(data.data);
          setOpen(true);
        }
      },
    }
  );
  const { mutateAsync: VerifyOtpForGetCustomerInformationMutate } = useMutation(
    VerifyOtpForGetCustomerInformation,
    {
      onSuccess: (data) => {
        if (data.isSuccess) {
          setDataVerifyCustomer(data.data);
          handleClose();
        }
      },
    }
  );
  const request = {} as customerInformationRequest;
  const date = convertToLocalDateTime(Number(birthDate)!);
  request.birthDate = date;
  request.branchId = branchId;
  request.nationalCode = nationalCode;
  // const [resendOtp, setResendOtp] = useState<boolean>(false);
  return (
    <div>
      <CustomisedButton
        title={"دریافت کد اعتبارسنجی"}
        disable={disable}
        onClick={() => {
          SendOtpForGetCustomerInformationMutate(request);
        }}
        type="button"
      />

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Formik
          validateOnMount={true}
          initialValues={{} as verifyCustomerInformationRequest}
          validationSchema={validationFatcorNumber}
          onSubmit={async (values) => {
            values.key = dataSendOtp?.key!;
            values.branchId = branchId;
            VerifyOtpForGetCustomerInformationMutate(values);
          }}
        >
          {({
            handleSubmit,
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            resetForm,
          }) => (
            <form onSubmit={handleSubmit}>
              <Box
                sx={style}
                style={{ borderRadius: "6px", padding: "20px 35px 35px 30px" }}
                className="ModalCmp textCenter "
              >
                <div
                  style={{ width: "75%", margin: "auto" }}
                  className=" textCenter "
                >
                  <div>
                    <Typography className="textCenter mTop30 mbottom40">
                      <span>
                        کد <b>"تایید استعلام"</b> برای متقاضی ارسال شد. جهت
                        استعلام اعتبار متقاضی، کد تایید استعلام را در کادر زیر
                        وارد کنید.
                      </span>
                    </Typography>
                  </div>
                  <div className="mbottom40">
                    <MaterialTextFieldComponent
                      autoFocus={true}
                      helperText={touched.otp ? errors.otp : ""}
                      error={touched.otp && Boolean(errors.otp)}
                      placeHolder={"کد تایید استعلام"}
                      label={"کد تایید استعلام"}
                      required={true}
                      value={values.otp}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      onKeyDown={(event) => {
                        if (
                          event.code === "Space" ||
                          (!/^[0-9]$/.test(event.key) &&
                            event.code !== "Backspace")
                        )
                          event.preventDefault();
                      }}
                      name="otp"
                      id="otp"
                      autoComplete="off"
                      type="tel"
                      inputProps={{ maxLength: dataSendOtp?.otpLength }}
                    />
                    <CountDown
                      countDownValue={dataSendOtp?.otpLifetime!}
                      resendOtp={() => {
                        SendOtpForGetCustomerInformationMutate(request);
                        resetForm();
                      }}
                    />
                  </div>

                  <div>
                    <CustomisedButton
                      title={"تایید استعلام"}
                      disable={
                        values?.otp?.length < dataSendOtp?.otpLength! ||
                        values?.otp === undefined ||
                        values?.otp === null
                      }
                      onClick={() => {}}
                      type="submit"
                    />
                  </div>
                </div>
              </Box>
            </form>
          )}
        </Formik>
      </Modal>
    </div>
  );
}
